import { useEffect } from "react";
import Header from "@/sections/Header";
import FooterSection from "@/sections/Footer";
import { TeaserHero } from "@/components/academy/teaser/TeaserHero";
import { TeaserTicker } from "@/components/academy/teaser/TeaserTicker";
import { TeaserAudience, TeaserPreview } from "@/components/academy/teaser/TeaserSections";
import { TeaserCta } from "@/components/academy/teaser/TeaserCta";
import { track } from "@/lib/academy/actions";
import { usePageMeta } from "@/lib/usePageMeta";

const META = {
  title: "DCYB Academy · Coming Soon",
  description: "DCYB Academy is coming soon: practical lessons on the systems, businesses and careers behind digital infrastructure. Join the waitlist to hear first when it opens.",
  path: "/academy",
  image: "/dcyb-academy-og.png",
};

export default function AcademyTeaserPage() {
  usePageMeta(META);
  useEffect(() => { window.scrollTo(0, 0); track("academy_teaser_viewed"); }, []);
  return (
    <main data-testid="academy-page" className="academy-page relative">
      <Header />
      <div data-testid="academy-teaser" className="academy-brand">
        <TeaserHero />
        <TeaserTicker />
        <TeaserPreview />
        <TeaserAudience />
        <TeaserCta />
      </div>
      <FooterSection />
    </main>
  );
}
